<style scoped lang="less">
.el-button {
	margin-right: 0.4rem;
	background-color: transparent;
	border: 1px solid transparent;
	color: #fff;
	font-size: 0.8rem;
}

.form-control {
	// width: 20%;
	margin-right: 0.4rem;
}

p {
	white-space: inherit;
	overflow: inherit;
	text-overflow: inherit;
}

@media (max-width: 575px) {
	.usersxxs {
		li {
			width: 100%;
		}
	}

	.scolls {
		li {
			width: 100%;
			flex: 1 0 auto;
			width: 50%;
		}
	}

	.statisititl {
		p {
			width: 50% !important;
		}
	}
}

.usercard {
	padding: 1rem 0 1rem 1rem;
	display: flex;
	height: 12rem;
	align-items: center;
	overflow: hidden;
	width: 100%;
	background: linear-gradient(to right, #687ae1, #9994d5);
	border-radius: 10px;
	box-shadow: 5px 1px 10px 2px #687ae1;

	.usercardtitle {
		width: 70%;
	}

	p:first-child {
		font-size: 1.2rem;
		margin: 0 0 1rem 0;
		color: #fff;
	}

	p:last-child {
		margin: 0 0 1rem 0;
	}

	p {
		width: 100%;
		color: #fff;
	}

	img {
		width: 14rem;
		height: 6rem;
	}
}

.usertop {
	.usersxxs {
		width: calc(100%);
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		height: 12rem;
		// overflow: hidden;

		li:nth-of-type(2) {
			padding: 0 0 0 0.4rem;

			.usercardv {
				background-color: #d9534f;
				// margin-top: 1rem;
			}
		}

		li:nth-of-type(3) {
			padding: 0 0.4rem 0 0;

			.usercardv {
				background-color: #2e9c65;
				margin-top: 1rem;
			}
		}

		li:nth-of-type(4) {
			padding: 0 0 0 0.4rem;

			.usercardv {
				background-color: #2167fc;
				margin-top: 1rem;
			}
		}

		li {
			padding: 0 0.4rem 0 0;
			box-sizing: border-box;

			.usercardv {
				display: flex;
				align-items: center;
				justify-content: space-between;
				// margin: 0 0;
				// border: 1px solid;
				padding: 1rem 0;
				border-radius: 10px;
				background: #ffa319;
				box-shadow: 0px 0px 5px 0px;

				.ioon {
					font-size: 2rem;
					color: #fff;
					// border: 1px solid;
					margin: 0 0 1.4rem 0.8rem;
				}

				.careds {
					margin-right: 1rem;
					text-align: right;

					/deep/ .number-grow {
						color: #fff;
						font-size: 1.4rem;
					}

					p {
						color: #fff;
					}
				}
			}
		}
	}
}

.statisi {
	margin-top: 1rem;
	padding-bottom: 1rem;
	background-color: #fff;
	border-radius: 10px;
	border: 1px solid #0ab94a;

	.statisititlew {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: #0ab94a;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		color: #fff;
		margin-bottom: 1rem;

		/deep/ .el-input {
			input {
				width: 90%;
				height: 2rem;
				margin-right: 2rem;
				border-radius: 5px;
			}

			.el-input__prefix {
				top: -4px;
			}
		}

		.statisititl {
			display: flex;
			align-items: center;
			padding: 1rem 0;

			span {
				padding: 0 1rem;
				font-size: 1.8rem;
				box-sizing: border-box;
				margin-top: 4px;
			}

			p {
				font-size: 1.4rem;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;

				span {
					padding: 0;
					font-size: 0.8rem !important;
					box-sizing: border-box;
				}
			}
		}
	}
}

.statisiticenter {
	width: 100%;
	overflow: hidden;
	padding: 0 1rem;

	ul.scolls {
		--bs-gutter-x: 20px;
		--bs-gutter-y: 0;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-wrap: nowrap;
		/* flex-wrap: wrap; */
		margin-top: calc(-1 * var(--bs-gutter-y));
		margin-right: calc(-0.5 * var(--bs-gutter-x));
		margin-left: calc(-0.5 * var(--bs-gutter-x));
		overflow-x: scroll;
		overflow-y: none;
		margin: 0;
		height: 24rem;

		&::-webkit-scrollbar {
			display: none;
		}

		li {
			padding-right: 10px;
		}

		li:first-child {
			padding-left: 10px;
		}

		li:nth-child(4n) {
			margin-right: 10px;
		}
	}
}

.carouselitemlst {
	// border: 1px solid;
	// background: #12c2e9;
	height: 236px;
	cursor: pointer;

	img {
		width: 100%;
		height: 100%;
		border-radius: 10px;
	}

	.sbcontent {
		width: 100%;
		text-align: center;
		margin-top: 1rem;

		.sbcontenttitle {
			// background: linear-gradient(to right, #12c2e9, #c471ed, #f64f59);
			// -webkit-background-clip: text;
			color: #333;
			font-weight: 600;
			font-size: 1.2rem;
		}

		.sbid {
			font-size: 0.8rem;
			color: #7e8299;
			margin-top: 0.4rem;
		}

		button:hover {
			border: 1px solid #333;
			color: #fff;
			background-color: #5569ff !important;
		}

		button {
			padding: 0.4rem 1rem;
			border-radius: 6px;
			background-color: transparent;
			color: #5569ff;
			border: 1px solid #5569ff;
			margin-top: 1rem;
			font-size: 1rem;

			span {
				margin-left: 0.4rem;
				font-weight: 900;
			}
		}

		button:hover {
			background-color: #fff;
		}
	}
}

.statisititr {
	display: flex;
	align-items: center;
	width: 50%;
	justify-content: flex-end;

	span {
		margin: 0 1rem 0 0;
		font-size: 1.2rem;
		color: #fff;
		font-weight: 900;
		border: 1px solid;
		border-radius: 50%;
	}

	.classlisttagget {
		span {
			margin: 0;
			border-radius: 0;
			color: #000;
			border: 1px solid #ccc;
			background: #fff;
			padding: 0.4rem;
			font-size: 1rem;
		}
	}
}

.classlist {
	/deep/ .el-col:first-child {
		// border: 1px solid #FFA319;
		margin-top: 1rem;
	}

	.classlisttitlelew {
		width: 100%;

		.classlisttitle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			background-color: #ffa319;
			border-top-left-radius: 10px;
			border-top-right-radius: 10px;
			color: #fff;
			margin-bottom: 1rem;

			.statisititl {
				display: flex;
				align-items: center;
				padding: 0.6rem 0;

				span {
					padding: 0 1rem;
					font-size: 1.8rem;
					box-sizing: border-box;
					margin-top: 4px;
				}

				p {
					width: 100%;
					font-size: 1.2rem;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;

					span {
						padding: 0;
						font-size: 0.8rem !important;
						box-sizing: border-box;
					}
				}
			}

			/deep/ .el-input {
				input {
					width: 90%;
					height: 2rem;
					margin-right: 2rem;
					border-radius: 5px;
				}

				.el-input__prefix {
					top: -4px;
				}
			}
		}
	}
}

.userlist {
	background: #fff;
	padding-bottom: 1rem;

	.wxscllo {
		width: 100%;
		padding: 0 2.5%;
		text-align: center;
		margin-top: 1rem;
		overflow: scroll;
		overflow-x: hidden;
		height: 26rem;
		border-top: 1px solid #e7e7e7;

		&::-webkit-scrollbar {
			display: none;
		}

		.list {
			margin-top: 1rem;
		}

		.list-item {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0.4rem 0 0.4rem 0;
			border-bottom: 1px solid #f4f4f4;

			button {
				padding: 0.2rem 1rem;
				border: 1px solid;
				border-radius: 40px;
				color: #fff;
				background-color: #57ca22;
				font-size: 0.8rem;

				span {
					margin-left: 4px;
				}
			}

			.username {
				// margin-right: 7rem;
				text-align: left;
				margin-left: 0.4rem;

				p {
					margin-bottom: 2px;
					color: #333;
					font-weight: 800;
					font-size: 0.8rem;
				}

				span {
					color: #57ca22;
				}
			}
		}
	}

	.inouts {
		width: 95%;
		margin: 0 auto;
		padding: 0 0 0 0;
		box-sizing: border-box;

		span {
			position: relative;
			top: 29px;
			font-size: 1.2rem;
			color: #333;
			left: 9px;
		}

		input {
			padding: 0.4rem 2rem;
			width: 100%;
			font-size: 1rem;
			border-radius: 40px;
			box-shadow: 2px 0 10px 4px #e2e2e2;
			box-sizing: border-box;
			border: 1px solid transparent;
		}
	}
}

.calsnum {
	border: 1px solid;
	width: 30%;
	text-align: center;
	border-radius: 5px;
	color: #fff;
	background: #2e9c65;
}

.calsbtn {
	border: 1px solid;
	padding: 0.4rem 0.6rem;
	border-radius: 11px;
	color: #fff;
	background: #2b81e2;
	font-size: 0.8rem;
}

.classlisttable {
	/deep/ th {
		.cell {
			color: #000;
			font-weight: 700;
		}
	}
}

/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}
}

.datafx {
	background-color: #0cbb4c !important;
}

.datars {
	background-color: #dd2255 !important;
}
</style>
<template>
	<div>
		<titles titlename="数据分析与统计" titlecontent="数据分析与统计" :mbx="paths"></titles>
		<el-row :gutter="20">
			<el-col :span="widths">
				<div class="usercard">
					<div class="usercardtitle">
						<p>数据统计分析功能操作说明</p>
						<p>
							统计分析包括：实训设备的数量、使用效率、空置率进行分析； 班级总数、用户总数；班级、单个用户的实训情况（累计实训次数、累计实训时长、
							熟练程度、综合能力等...）进行分析。
						</p>
					</div>
					<img src="./../../images/shujutoji.svg" alt="" />
				</div>
			</el-col>
			<el-col :span="widths">
				<div class="usertop">
					<ul class="usersxxs">
						<li class=" col-sm-12 col-md-6 col-lg-6">
							<div class="usercardv">
								<span class="el-icon-files ioon"></span>
								<div class="careds" v-if="isdatanunbear == 0">
									<!-- <numbergrow :value="datanunbear.trainECount"></numbergrow> -->
									<p style="font-size: 1.4rem;font-weight: 600;">{{ datanunbear.trainECount }}</p>
									<p>
										实训设备总数
										<span class="el-icon-caret-right"></span>
									</p>
								</div>
							</div>
						</li>
						<li class=" col-sm-12 col-md-6 col-lg-6">
							<div class="usercardv">
								<span class="el-icon-s-custom ioon"></span>
								<div class="careds" v-if="isdatanunbear == 0">
									<!-- <numbergrow :value=""></numbergrow> -->
									<p style="font-size: 1.4rem;font-weight: 600;">{{ datanunbear.studentPCount }}</p>
									<p>
										学员总数
										<span class="el-icon-caret-right"></span>
									</p>
								</div>
							</div>
						</li>
						<li class=" col-sm-12 col-md-6 col-lg-6">
							<div class="usercardv">
								<span class="el-icon-odometer ioon"></span>
								<div class="careds" v-if="isdatanunbear == 0">
									<p style="font-size: 1.4rem;font-weight: 600;">{{ datanunbear.trainTime }}</p>
									<!-- <numbergrow :value=""></numbergrow> -->
									<p>
										累计实训时长（小时）
										<span class="el-icon-caret-right"></span>
									</p>
								</div>
							</div>
						</li>
						<li class="col-sm-12 col-md-6 col-lg-6">
							<div class="usercardv" v-if="isdatanunbear == 0">
								<span class="el-icon-basketball ioon"></span>
								<div class="careds">
									<p style="font-size: 1.4rem;font-weight: 600;">{{ datanunbear.classCount }}</p>
									<!-- <numbergrow :value="datanunbear.classCount"></numbergrow> -->
									<p>
										班级总数
										<span class="el-icon-caret-right"></span>
									</p>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</el-col>
		</el-row>

		<div class="statisi">
			<div class="statisititlew">
				<div class="statisititl">
					<span class="el-icon-help"></span>
					<p>
						设备列表
						<span>请选择要进行数据分析的设备</span>
					</p>
				</div>
				<div class="statisititr">
					<select v-model="siguid" class="form-control" id="exampleFormControlSelect1" placeholder="请选择实训室" @change="schoolsid()">
						<!-- <option value="">-- 请选择实训室 --</option> -->
						<option v-for="(item, index) in schoolchlist" :key="index" :label="item.si_name_cn" :value="item.si_guid">{{ item.si_name_cn }}</option>
					</select>

					<select v-model="trainsbobjs.sx_tr_guid" class="form-control" id="exampleFormControlSelect1" placeholder="请选择实训室">
						<!-- <option value="">-- 请选择实训室 --</option> -->
						<option v-for="(item, index) in trainlist" :key="index" :value="item.sx_tr_guid">{{ item.tr_name }}</option>
					</select>
					<input type="text" class="form-control" id="exampleFormControlSelect1" v-model="trainsbobjs.searchs" placeholder="请输入实训设备名字" />
					<el-button @click="sititrsearch()" icon="el-icon-search" round size="mini">查询</el-button>

					<span class="el-icon-arrow-left" @click="leftgo()"></span>
					<span class="el-icon-arrow-right" @click="rightgo()"></span>
				</div>
			</div>

			<div class="statisiticenter">
				<el-empty v-if="getsrainsbeiacg.length == 0" description="暂无实训室,请添加实训室"></el-empty>
				<ul v-else class="scolls">
					<!-- {{getsrainsbeiacg}} -->
					<li class="col-sm-6 col-md-6 col-lg-3" v-for="(item, index) in getsrainsbeiacg" :key="index">
						<div class="carouselitemlst" @click.stop="goroomxq(item)">
							<img v-if="item.te_image !== ''" :src="item.te_image" alt="" />
							<img v-else src="./../../images/rooming.jpg" alt="" />
							<div class="sbcontent">
								<p class="sbcontenttitle">{{ item.te_deviceName }}</p>
								<p class="sbid">
									设备编号 &nbsp;&nbsp;
									<br />
									{{ item.te_deviceNumber }}
								</p>
								<button @click.stop="goroomxq(item)">
									使用情况分析
									<span class="el-icon-right"></span>
								</button>
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>

		<div class="classlist">
			<el-row :gutter="20">
				<el-col :xs="24" :sm="24" :md="15" :lg="16" :xl="16">
					<div class="classlisttitlelew" style="border: 1px solid #FFA319;border-top-left-radius: 10px;border-top-right-radius: 10px;">
						<div class="classlisttitle" style="margin-bottom: 0;">
							<div class="statisititl">
								<span class="el-icon-help"></span>
								<p>
									班级列表
									<span>请选择要进行数据分析的设备</span>
								</p>
							</div>
							<div class="statisititr">
								<el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="calsearch"></el-input>
								<el-button @click="statitrsearch()" icon="el-icon-search" round size="mini">查询</el-button>
								<!-- <div class="classlisttagget" style="display: flex;align-items: center;">
									<span class="el-icon-menu"></span>
									<span class="el-icon-s-grid" style="margin-right:10px;"></span>
								</div> -->
							</div>
						</div>
						<div class="classlist" style="padding-bottom: 6rem;background: #fff;">
							<div class="classlisttable" v-if="tabs == 1">
								<template>
									<el-table
										:row-class-name="tableRowClassName"
										header-row-class-name="tablestitle"
										:data="tableData"
										style="width: 100%"
										@row-click="classrowclick"
									>
										<el-table-column fixed prop="cla_name" :resizable="false" label="班级名称"></el-table-column>
										<el-table-column prop="cla_nameNumber" :resizable="false" label="班级编号"></el-table-column>
										<el-table-column prop="classnum" :resizable="false" label="班级人数">
											<template slot-scope="scope" class="btnclas">
												<p class="calsnum" :class="{ datars: scope.row.index == tablesindex }">{{ scope.row.cla_count }}</p>
											</template>
										</el-table-column>
										<el-table-column prop="pro_name" :resizable="false" label="所属专业"></el-table-column>
										<el-table-column fixed="right" :resizable="false" prop="classimg" label="事件">
											<template slot-scope="scope" class="btnclas">
												<el-button
													class="calsbtn"
													accesskey=""
													:class="{ datafx: scope.row.index == tablesindex }"
													@click="handleClick(scope.row)"
													type="text"
													size="small"
												>
													数据分析
													<span class="el-icon-right"></span>
												</el-button>
											</template>
										</el-table-column>
									</el-table>
								</template>
							</div>
							<div style="width: 100%;text-align: center;margin-top: 1rem;">
								<el-pagination @current-change="handleCurrentChange" :page-size="pageSize" layout="prev, pager, next" :total="pagetotal"></el-pagination>
							</div>
						</div>
					</div>
				</el-col>
				<el-col :xs="24" :sm="24" :md="9" :lg="8" :xl="8">
					<div class="userlist" style="margin-top: 1rem;border: 1px solid #5569FF;border-radius: 12px;">
						<div class="classlisttitlelew">
							<div class="classlisttitle" style="background-color: #5569FF;margin-bottom: 0;">
								<div class="statisititl">
									<span class="el-icon-help" style="font-size: 1rem;"></span>
									<p style="font-size: 1rem;">
										{{ clasnames }}成员列表
										<span>点击按钮进行分析</span>
									</p>
								</div>
							</div>
						</div>

						<div class="infinite-list-wrapper" style="overflow:auto">
							<div class="inouts">
								<span class="el-icon-search" @click="changestudent"></span>
								<input type="text" placeholder="搜索..." v-model="studentsearch" @change="changestudent" />
							</div>
							<div class="wxscllo">
								<ul class="list" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
									<li v-for="(item, index) in studentlist" :key="index" class="list-item">
										<div style="display: flex;align-items: center;justify-content: flex-start;">
											<img style="width: 3vw;height: 3vw;border-radius: 50%;" v-if="item.ui_photoPath" :src="item.ui_photoPath" alt="" />
											<img style="width: 3vw;height: 3vw;border-radius: 50%;" v-else src="../../images/header.jpg" alt="" />
											<div class="username">
												<p>{{ item.ui_realName }}</p>
												<span>
													学号：
													<i>{{ item.ui_joyNumber }}</i>
												</span>
											</div>
										</div>
										<button @click="goclasstatis(item)">
											分析
											<span class="el-icon-s-help"></span>
										</button>
									</li>
								</ul>
								<p v-if="loading">加载中...</p>
								<p style="overflow: hidden;" v-if="noMore">没有更多了</p>
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import numbergrow from '@/components/numberdt/numbergrow.vue';
import $ from 'jquery';
import { GetchatChartIndex, GetdataPageClassSTAList, GetdataClassStuinfoList } from '@/request/api/dataorder/dataprder.js';
import { getPageTrainEquipmentList, getbfyGetTrainList, getTrainEquipmentList } from '@/request/api/trainroom/trainroom.js';

import { GetbjGetSchoolList } from '@/request/api/mange/mange.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			isdatanunbear: 1,
			// 班级列表搜索
			calsearch: '',
			studentsearch: '',
			trainlist: [],
			trainsbobjs: {
				sx_tr_guid: '',
				searchs: ''
			},
			pagetotal: 4,
			pageSize: 5,
			pageIndex: 1,
			// 数据分析
			datanunbear: {},
			getsrainsbeiacg: [],
			// 表格
			tableData: [],
			// 搜索
			sbsearch: '',
			// 标题
			paths: [
				{
					path: '/allmanage/statistics',
					name: '数据分析与统计'
				}
			],
			//	页面尺寸
			widths: 12,
			screenwidth: '',
			scrollwidth: 320,
			// 计算右边滑动次数
			nums: 1,
			// 无限滚动
			count: 10,
			loading: false,
			tabs: 1,
			// 分页器
			currentPage2: 1,
			// 班级选择
			classnums: 0,
			// 获取学生id
			studentsid: '',
			studentlist: [],
			clasnames: '',
			// table索引
			tablesindex: 0,
			// 学校不分页
			siguid: localStorage.getItem('siguid'),
			schoolchlist: []
		};
	},
	components: {
		titles,
		numbergrow
	},
	created() {
		AppOptions.appEmpty = false;
	},
	beforeMount() {
		GetbjGetSchoolList().then(res => {
			this.schoolchlist = res.data.data;

			if (localStorage.getItem('siguid')) {
				this.siguid = localStorage.getItem('siguid');
				// console.log("拿一下学校",this.siguid)
				this.gettrains(localStorage.getItem('siguid'));
				this.getdataall();
				this.getscools();
			} else {
				this.siguid = res.data.data[0].si_guid;

				this.gettrains(res.data.data[0].si_guid);
				this.getdataall();
				this.getscools();
			}
			// console.log(this.siguid)
		});
	},
	mounted() {
		this.relazy();
		// console.log(window.screenWidth)
		this.relats();

		// this.scrollwidth = $(this.$refs.colss[0]).width() + 10 * 2
	},
	updated() {
		// console.log($(".scolls li").eq(0))
		this.scrollwidth =
			$('.scolls li')
				.eq(0)
				.width() +
			10 * 2;
	},
	// 无限滚动
	computed: {
		noMore() {
			return this.count >= 20;
		},
		disabled() {
			return this.loading || this.noMore;
		}
	},
	watch: {},
	methods: {
		schoolsid() {
			this.gettrains();
			this.getdataall();
			this.getscools();
		},
		gettrains(id) {
			// console.log(localStorage.getItem("siguid"),"这里拿得到siguid嘛")

			getbfyGetTrainList(this.siguid).then(res => {
				// console.log(res, "实训室不分页")
				this.trainlist = res.data.data;
				let trainsobj = {
					sx_tr_guid: '',
					tr_name: '请选择实训室'
				};
				this.trainlist.unshift(trainsobj);
				if (res.data.data.length > 0) {
					this.trainsbobjs.sx_tr_guid = res.data.data[0].sx_tr_guid;
				} else {
					this.trainsbobjs.sx_tr_guid = '';
				}
				this.getsrainsbeimg();
			});
		},

		// 搜索学员
		changestudent() {
			this.getclasstdebt();
		},
		statitrsearch() {
			this.getscools();
		},
		// 去学员分析
		goclasstatis(itm) {
			let tains = JSON.stringify(itm);
			this.$cookie.set('stindenbin', tains);
			this.$router.push({
				name: '学员个人分析'
			});
		},

		// 去班级分析
		handleClick(itm) {
			let tains = JSON.stringify(itm);
			this.$cookie.set('classbin', tains);
			this.$router.push({
				path: '/information/classstatistics'
			});
		},
		// 点击跳转
		goroomxq(itm) {
			// console.log(itm)
			let tains = JSON.stringify(itm);
			localStorage.setItem('trainbin', tains);

			this.$router.push({
				path: '/information/devicetatistics?stid=' + itm.sx_te_guid
			});
		},

		tableRowClassName({ row, rowIndex }) {
			row.index = rowIndex;
		},

		getclasstdebt() {
			let studentobj = {
				cla_guid: this.studentsid,
				ui_realName: this.studentsearch
			};
			GetdataClassStuinfoList(studentobj).then(res => {
				// console.log(res, "根据班级获取学员")
				this.studentlist = res.data.data;
			});
		},

		// 点击班级列表
		async classrowclick(row) {
			// console.log(row)
			if (row.index !== this.tablesindex) {
				// 如果点击的当前行的索引 不同的时候，
				//  进行一些操作， 比如访问接口请求参数，
				//  如果一样的话， 就不做请求， 还是原来的数据。
				// console.log("索引不同")
				this.tableData[row.index].classnums = 1;
				this.studentsid = row.cla_guid;
				this.clasnames = this.tableData[row.index].cla_name;
				await this.getclasstdebt();
			}
			//让点击的这行索引赋值给变量index
			this.tablesindex = row.index;
		},
		// 获取学校
		getscools() {
			let MenuListobj = {
				pageIndex: this.pageIndex,
				pageSize: this.pageSize,
				cla_name: this.calsearch,
				si_guid: this.siguid
			};
			GetdataPageClassSTAList(MenuListobj).then(res => {
				// console.log(res, "获取班级")
				this.tableData = res.data.data.list;
				this.pagetotal = res.data.data.totalCount;
				this.tableData.forEach(item => {
					item.classnums = 0;
				});

				if (res.data.data.list.length > 0) {
					this.tableData[0].classnums = 1;
					this.studentsid = this.tableData[0].cla_guid;
					this.clasnames = this.tableData[0].cla_name;
					this.getclasstdebt();
				} else {
					this.studentlist = [];
				}
			});
		},

		// 搜索设备
		sititrsearch() {
			this.getsrainsbeimg();
		},

		// 获取设备列表
		getsrainsbeimg() {
			let tsrains = {
				si_guid: this.siguid,
				sx_tr_guid: this.trainsbobjs.sx_tr_guid,
				te_deviceName: this.trainsbobjs.searchs
			};

			getTrainEquipmentList(tsrains).then(res => {
				// console.log(res.data.data, "设备不分页")
				let trinaslist = res.data.data;
				this.getsrainsbeiacg = trinaslist;
				// console.log(this.getsrainsbeiacg, "这个拿到的数据")
				// console.log(this.getsrainsbeiacg instanceof Array,"测试类型")
			});
		},

		// 获取数据分析
		getdataall() {
			let siguid = this.siguid;
			GetchatChartIndex(siguid).then(res => {
				console.log(res, '数据分析');
				this.datanunbear = res.data.data;
				this.isdatanunbear = 0;
				this.$set(this.datanunbear, 'classCount', res.data.data.classCount);
				this.$set(this.datanunbear, 'studentPCount', res.data.data.studentPCount);
				this.$set(this.datanunbear, 'trainECount', res.data.data.trainECount);
				this.$set(this.datanunbear, 'trainTime', res.data.data.trainTime);
			});
		},

		// 分页器
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.getscools();
			// console.log(`当前页: ${val}`);
		},

		// 无限滚动
		load() {
			this.loading = true;
			setTimeout(() => {
				this.count += 2;
				this.loading = false;
			}, 1000);
		},
		// 点击事件
		leftgo() {
			// console.log("左边")
			// console.log($(".scolls").scrollLeft())
			$('.scolls').scrollLeft();
			if ($('.scolls').scrollLeft() == 0) {
				console.log($('.scolls').scrollLeft());
			} else {
				$('.scolls').animate(
					{
						scrollLeft: $('.scolls').scrollLeft() - this.scrollwidth * 2
					},
					1000
				);
			}
		},
		rightgo() {
			this.nums++;
			$('.scolls').animate(
				{
					scrollLeft: $('.scolls').scrollLeft() + this.scrollwidth * 2
				},
				1000
			);
			// console.log($(".scolls").scrollLeft())
			// $(".scolls").scrollLeft($(".scolls").scrollLeft() + this.scrollwidth)
		},

		relats() {
			// p元素改变
			if (document.body.clientWidth < 1300 && document.body.clientWidth > 950) {
				// console.log("进入1300")
				$('.usercardtitle>p').css({
					overflow: 'hidden',
					'white-space': 'nowrap',
					'text-overflow': 'ellipsis'
				});
			}

			if (document.body.clientWidth > 1300 || document.body.clientWidth < 950) {
				// console.log("出了1300")
				$('.usercardtitle>p').css({
					overflow: 'inherit',
					'white-space': 'inherit',
					'text-overflow': 'inherit'
				});
			}

			if (document.body.clientWidth < 950) {
				this.widths = 24;

				// console.log(document.body.clientWidth)
				$('.usertop').css({
					'margin-top': '10px',
					height: '24vh'
				});
				$('.usersxxs li').css({
					'margin-top': '10px',
					padding: '0'
				});
				$('.usersxxs li:odd').css('padding', '0 0 0 0.4rem');
				$('.usersxxs li:even').css('padding', '0 0.4rem 0 0');
				// $(".usersxxs").css()
			}

			if (document.body.clientWidth > 950) {
				// console.log(document.body.clientWidth)
				$('.usertop').css('height', 'auto');
				this.widths = 12;
				$('.usersxxs li').css('margin-top', '0');
				$('.usersxxs li:odd').css('padding', '0 0 0 0.4rem');
				$('.usersxxs li:even').css('padding', '0 0.4rem 0 0');
			}

			if (document.body.clientWidth < 768) {
				// console.log(document.body.clientWidth)
				console.log('进入小屏幕');
				$('.usertop').css('height', '25rem');
				$('.usersxxs li').css({
					padding: '0'
				});
				$('.usersxxs li>.usercardv').css({
					margin: '0'
				});
			}
		},
		relazy() {
			window.onresize = () => {
				return (() => {
					this.screenwidth = document.body.clientWidth;

					// p元素改变
					if (this.screenwidth < 1300 && this.screenwidth > 950) {
						// console.log("进入1300")
						$('.usercardtitle>p').css({
							overflow: 'hidden',
							'white-space': 'nowrap',
							'text-overflow': 'ellipsis'
						});
					} else {
						// console.log("出了1300")
						$('.usercardtitle>p').css({
							overflow: 'inherit',
							'white-space': 'inherit',
							'text-overflow': 'inherit'
						});
					}

					if (this.screenwidth < 950) {
						this.widths = 24;
						// console.log("app")
						this.widths = 24;

						$('.usertop').css({
							'margin-top': '10px',
							height: '24vh'
						});
						$('.usersxxs li').css({
							'margin-top': '10px',
							padding: '0'
						});
						$('.usersxxs li:odd').css('padding', '0 0 0 0.4rem');
						$('.usersxxs li:even').css('padding', '0 0.4rem 0 0');
					} else {
						this.widths = 12;

						$('.usertop').css({
							'margin-top': '0',
							height: 'auto'
						});
						this.widths = 12;

						$('.usersxxs li').css('margin-top', '0');
						$('.usersxxs li:odd').css('padding', '0 0 0 0.4rem');
						$('.usersxxs li:even').css('padding', '0 0.4rem 0 0');
					}

					if (this.screenwidth < 768) {
						$('.usertop').css('height', '25rem');
						$('.usersxxs li').css({
							padding: '0'
						});
						$('.usersxxs li>.usercardv').css({
							margin: '0'
						});
					}
				})();
			};
		}
	}
};
</script>

<style></style>
